import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/80'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="text-xl font-bold text-primary-500 font-heading">韩漫网</span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
              location.pathname === '/' ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'
            }`}
          >
            首页
          </Link>

          <div className="relative" onMouseEnter={() => setCategoryOpen(true)} onMouseLeave={() => setCategoryOpen(false)}>
            <button className="flex items-center gap-1 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              分类
              <i className={`ri-arrow-down-s-line text-xs transition-transform duration-200 ${categoryOpen ? 'rotate-180' : ''}`}></i>
            </button>
            {categoryOpen && (
              <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 bg-background-50 rounded-lg border border-background-200/80 py-3 px-4 min-w-[480px] grid grid-cols-2 gap-1 z-50">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground-600 hover:bg-background-100 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={`${cat.icon} text-primary-400`}></i>
                    </span>
                    {cat.name}
                  </Link>
                ))}
              </div>
            )}
          </div>

          <Link
            to="/about"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
              location.pathname === '/about' ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'
            }`}
          >
            关于我们
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <div className="relative">
            <input
              type="text"
              placeholder="搜索漫画..."
              className="w-48 pl-8 pr-3 py-1.5 text-sm bg-background-100 border border-background-200 rounded-full focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 text-foreground-700 placeholder:text-foreground-300 transition-all duration-200"
            />
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          </div>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-3">
          <Link to="/" className="text-sm font-medium text-foreground-700 py-2">首页</Link>
          <p className="text-sm font-medium text-foreground-500 py-1">分类</p>
          <div className="grid grid-cols-2 gap-1 pl-2">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-2 text-sm text-foreground-600 py-1.5"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-primary-400 text-xs`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
          </div>
          <Link to="/about" className="text-sm font-medium text-foreground-700 py-2">关于我们</Link>
          <div className="relative mt-2">
            <input
              type="text"
              placeholder="搜索漫画..."
              className="w-full pl-8 pr-3 py-2 text-sm bg-background-100 border border-background-200 rounded-full focus:outline-none focus:border-primary-300 text-foreground-700 placeholder:text-foreground-300"
            />
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          </div>
        </div>
      )}
    </header>
  );
}